var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeclined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.464,
    height: 11.464,
    viewBox: "0 0 11.464 11.464",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Declined",
    transform: "translate(-153.408 -329.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "close_FILL0_wght400_GRAD0_opsz48_1_",
    "data-name": "close_FILL0_wght400_GRAD0_opsz48 (1)",
    d: "M11.232,21.814l-.882-.882,4.85-4.85-4.85-4.85.882-.882,4.85,4.85,4.85-4.85.882.882-4.85,4.85,4.85,4.85-.882.882-4.85-4.85Z",
    transform: "translate(143.058 318.888)",
    fill: "#9bacb1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclined);
export default __webpack_public_path__ + "static/media/declined.ac8a8509b77687b75db25598dcf73663.svg";
export { ForwardRef as ReactComponent };